import { useMatch, useNavigate } from '@tanstack/react-router';
import { ReactNode, useEffect } from 'react';

import { useGetAboutYouSurveySubmittedQuery } from '@/api/api-hooks';
import { AppSkeletonLoader } from '@/components/AppSkeletonLoader';
import { useUser } from '@/hooks/useUser';

type SelfServiceSurveyGateProps = {
  children: ReactNode;
};

export function SelfServiceSurveyGate({ children }: SelfServiceSurveyGateProps) {
  const navigate = useNavigate();
  const { isSelfService, organizationName } = useUser();

  const isOnAboutYouRoute = !!useMatch({ from: '/$organizationName/about-you', shouldThrow: false });

  const { data, isLoading } = useGetAboutYouSurveySubmittedQuery({
    enabled: isSelfService && !isOnAboutYouRoute,
  });

  useEffect(() => {
    if (!isSelfService || isOnAboutYouRoute) return;
    if (data && organizationName && !data.submitted) {
      navigate({ to: '/$organizationName/about-you', params: { organizationName }, replace: true });
    }
  }, [data, isOnAboutYouRoute, isSelfService, navigate, organizationName]);

  if (isSelfService && !isOnAboutYouRoute && (isLoading || data?.submitted === false)) {
    return <AppSkeletonLoader />;
  }

  return children;
}
